import { Component, Input } from '@angular/core';
import { Comment } from '@completion/models';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss'],
  standalone: false,
})
export class NoteComponent {
  @Input() comment: Comment;

  get dataCommentId(): string | null {
    if (!this.comment) return null;
    const asAny = this.comment as any;
    if (asAny.id != null) return String(asAny.id);
    if (asAny.commentId != null) return String(asAny.commentId);
    return null;
  }
}
